/*-------------------------------------------------------------------------------
  Aside Menu
  -------------------------------------------------------------------------------*/
$(document).ready(function() {
    $(".aside-trigger-left").on('click', function() {
        $(".sigma_aside-left").toggleClass('open');
    });

    $(".sigma_aside .menu-item-has-children > a").on('click', function(e) {
        var submenu = $(this).next(".sub-menu");
        e.preventDefault();

        submenu.slideToggle(200);
    });
})

